import { render, staticRenderFns } from "./AssetsChart.vue?vue&type=template&id=84a62618&scoped=true"
import script from "./AssetsChart.vue?vue&type=script&lang=js"
export * from "./AssetsChart.vue?vue&type=script&lang=js"
import style0 from "./AssetsChart.vue?vue&type=style&index=0&id=84a62618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a62618",
  null
  
)

export default component.exports